import React from 'react';
import { ApiButton } from 'web-library';
import { ButtonVariant } from 'web-library/stories/atom/Button/Button';

export enum PaymentMethod {
  ENETS_CREDIT_CARD = 'ENETS_CREDIT_CARD',
  BANK_TRANSFER = 'BANK_TRANSFER',
  PAYNOW_QR = 'PAYNOW_QR',
}

interface PaymentButtonProps {
  buttonClassName?: string;
  onClickPaymentButton: (callback: (hasConfirmModal?: boolean) => void) => void;
  disabled?: boolean;
  buttonText?: string;
  fullWidth?: boolean;
  buttonVariant?: ButtonVariant;
  setStateHandler: {
    setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
    setIsPaymentModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setSelectedPaymentMethod: React.Dispatch<React.SetStateAction<PaymentMethod | null>>;
    setIsConfirmationModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  };
}

const PaymentApiButton = ({
  buttonClassName,
  onClickPaymentButton,
  disabled,
  buttonText,
  fullWidth,
  buttonVariant,
  setStateHandler,
}: PaymentButtonProps) => {
  const {
    setIsDisabled,
    setIsPaymentModalOpen,
    setSelectedPaymentMethod,
    setIsConfirmationModalOpen,
  } = setStateHandler;
  return (
    <ApiButton
      id="button-paymentButton-proceedToPayment"
      fullWidth={fullWidth}
      status="idle"
      variant={buttonVariant}
      className={buttonClassName}
      onClick={() => {
        setIsDisabled(false);
        const onClickPaymentCallback = (hasConfirmModal = false) => {
          if (hasConfirmModal) {
            setIsConfirmationModalOpen(true);
          } else {
            setIsPaymentModalOpen(true);
            setSelectedPaymentMethod(null);
          }
        };
        onClickPaymentButton((hasConfirmModal) => onClickPaymentCallback(hasConfirmModal));
      }}
      disabled={disabled}
    >
      {buttonText || 'Proceed to Payment'}
    </ApiButton>
  );
};

export default PaymentApiButton;
